export default __webpack_public_path__ + "locales/de/Translations.json?hash=b1d8e3001716f7f86be453ef468c2827";